var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sideblock-delivery"},[_c('div',{staticClass:"sideblock-delivery__body"},[_c('common-fitting-info')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }